// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/rtl/_index.scss
// module id = 79
// module chunks = 0